<div class="relative">
  <button
    type="button"
    class="inline-flex items-center justify-center p-1 -mt-1 leading-none rounded hover:bg-surface-switch-200 hover:text-primary-500 cursor-pointer"
    [class.text-primary-500]="isFilterActive"
    (click)="toggleDropdown()"
  >
    <i [class]="isFilterActive ? 'pi pi-filter-fill' : 'pi pi-filter'"></i>
  </button>

  @if (dropdownOpen) {
    <div
      class="absolute top-full left-1/2 -translate-x-1/2 mt-2 z-20 min-w-[220px] rounded-md p-3 shadow-lg bg-surface-switch-0 border border-surface-switch-100"
    >
      <div class="relative mb-2">
        <span
          class="absolute inset-y-0 left-0 flex items-center pl-4 text-gray-400"
        >
          <i class="pi pi-search text-base"></i>
        </span>
        <input
          type="text"
          placeholder="Search..."
          [(ngModel)]="searchTerm"
          class="w-full pl-10 pr-4 py-2.5 rounded-md border bg-surface-switch-0 border-surface-switch-200 placeholder:text-muted-color font-normal focus:outline-none focus:border-primary"
        />
      </div>
      <div
        class="ml-1 mt-1 space-y-2 border-l-2 border-surface-switch-300 pl-3 max-h-56 overflow-y-auto pr-2"
      >
        @for (
          option of filteredOptions | slice: 0 : displayLimit;
          track option
        ) {
          <label
            class="flex items-center gap-2 cursor-pointer text-sm text-surface-switch-900"
          >
            <input
              type="checkbox"
              class="accent-primary-500"
              [checked]="selectedValues.includes(option)"
              (change)="onSelectionChange(option, $any($event.target).checked)"
            />
            <span class="truncate normal-case">
              {{ columnKey === "created_date" ? formatDate(option) : option }}
            </span>
          </label>
        }
      </div>

      <div class="mt-3 pt-2 text-right border-t border-surface-switch-100">
        <button
          pButton
          type="button"
          label="Clear"
          class="p-button-sm p-button-text"
          (click)="clearFilters()"
        ></button>
      </div>
    </div>
  }
</div>
